import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { TechRootState, AppDispatch } from './TechStore'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<TechRootState> = useSelector